<template>
  <div id="app">
    <Notes 
    :notes="notes"
    :roomslookup="roomslookup"
    :audiences="audiences"
    v-if="appstate === 'notes'">
    </Notes>

    <section id="rooms" v-if="appstate === 'rooms'">
      <template>
        <header class="toolbar">
          <div class="tools">
            <button
              v-on:click="toggleFilterBar()"
              v-bind:class="{'selected' : showFilterBar }"
            >
              Filtrera
            </button>
            <button
              v-on:click="toggleSearchBar()"
              v-bind:class="{'selected' : showSearchBar }"
            >
              Sök
            </button>
            <button
              v-on:click="toggleSelectingMultiple()"
              v-bind:class="{'selected' : selectingMultiple }"
            >
              <span v-if="!selectingMultiple">Välj flera</span>
              <span v-if="selectingMultiple">Avbryt</span>
            </button>
          </div>

          <div class="tool-panels">
            
            <ul 
              class="tool-panel filters notes-filter alternative-list"
              v-if="showFilterBar"
            >
              <li 
              v-for="(status, key) in statuses" 
              v-bind:key="key"
              v-bind:data-status="key" v-html="status" 
              v-on:click="setRoomStatusFilter(key)" 
              v-bind:class="{'selected': room_status_filter === key}"
              ></li>
              <li 
              v-on:click="room_status_filter = ''"
              v-bind:class="{'selected': room_status_filter === ''}"
              >Alla</li>

            </ul>

            <div 
              class="tool-panel search"
              v-if="showSearchBar"
            >
              <input type="text" v-model="roomSearch" ref="searchInput" placeholder="Skriv för att söka">
              <button
                v-on:click="clearAndCloseSearch"
                class="close-search"
              >
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 26 26" style="enable-background:new 0 0 26 26;" xml:space="preserve">
                  <g>
                    <path style="fill:#030104;" d="M21.125,0H4.875C2.182,0,0,2.182,0,4.875v16.25C0,23.818,2.182,26,4.875,26h16.25
                      C23.818,26,26,23.818,26,21.125V4.875C26,2.182,23.818,0,21.125,0z M18.78,17.394l-1.388,1.387c-0.254,0.255-0.67,0.255-0.924,0
                      L13,15.313L9.533,18.78c-0.255,0.255-0.67,0.255-0.925-0.002L7.22,17.394c-0.253-0.256-0.253-0.669,0-0.926l3.468-3.467
                      L7.221,9.534c-0.254-0.256-0.254-0.672,0-0.925l1.388-1.388c0.255-0.257,0.671-0.257,0.925,0L13,10.689l3.468-3.468
                      c0.255-0.257,0.671-0.257,0.924,0l1.388,1.386c0.254,0.255,0.254,0.671,0.001,0.927l-3.468,3.467l3.468,3.467
                      C19.033,16.725,19.033,17.138,18.78,17.394z"/>
                  </g>
                </svg>

              </button>
            </div>
          </div>
        </header>
        <div 
          class="help"
          v-if="showHelp"
        >
          <div class="iframe-container">
            <button
              v-on:click="showHelp = false"
            >Stäng</button>
            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/taZdwiccSiE?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
        <ul 
          id="rooms-list"
          :class="{'accommodate-filterbar' : showFilterBar, 'accommodate-searchbar' : showSearchBar }"
        >
          <li 
          v-bind:class="room.status" 
          v-for="(room, i) in filteredRooms"
          v-bind:key="i"
          >
            <span
              v-if="selectingMultiple"
              class="multi-selectbox"
              :class="{'selected' : selectedRoomIds.includes(room.id) }"
            >
            </span>
            <span class="room-info" @click="toggleOrSelect(room)">
              <h2>{{ room.name }}</h2>
              <span class="current-status" v-html="statuses[room.status]"></span>
              <span class="updated-at">{{ room.lastupdated }}</span>
              <span class="notes-count" v-if="room.notes.length === 1"><span>{{ room.notes.length }} notering </span></span>
              <span class="notes-count" v-if="room.notes.length > 1"><span>{{ room.notes.length }} noteringar </span></span>
            </span>

            <template class="panel" v-if="room.open">
              <section class="panel status-panel">
                <div class="panel-inner">
                  <div class="meta">
                    <h2>{{ room.name }}</h2>
                    <span class="current-status" v-html="statuses[room.status]"></span>
                    <span class="updated-at">{{ room.lastupdated }}</span>
                  </div>
                  <div class="tabs">
                    <div 
                      class="tab-status"
                      :class="{'current-tab' : currentPanelTab === 'statuses' }"
                      v-on:click="currentPanelTab = 'statuses'"
                    >
                      Status
                    </div>
                    <div 
                      class="tab-notes"
                      :class="{'current-tab' : currentPanelTab === 'notes' }"
                      v-on:click="currentPanelTab = 'notes'"
                    >
                      Noteringar<span v-if="room.notes.length > 0"> ({{ room.notes.length }})</span>
                    </div>
                    <div 
                      class="close"
                      v-on:click="togglePanel(room)"
                    >
                      <i class="fas fa-window-close"></i>
                      Stäng
                    </div>
                  </div>
                  <ul 
                    class="statuses"
                    v-if="currentPanelTab === 'statuses'"
                  >
                    <li 
                    v-bind:class="index" 
                    v-for="(status, index) in statuses" @click="updateRoomStatus(room, index)"
                    v-bind:key="index"
                    >
                      <span v-html="status"></span>
                    </li>
                  </ul>
                  <div
                    v-if="currentPanelTab === 'notes'"
                  >
                    <ul class="note-tools">
                      <li 
                      class="create-note" 
                      @click="openNoteUi(room)"
                      >
                        <span><i class="fas fa-edit"></i> Skapa notering</span>
                      </li>
                    </ul>
                    <RoomNotes 
                    :room="room"
                    >
                    </RoomNotes>
                  </div>

                </div>
              </section>
            </template>
            
          </li>
        
        </ul>

        <div
          :class="{'open' : selectingMultiple && selectedRoomIds.length > 0}"
          class="selecting-multiple-panel"
        >
          <p><strong>Hanterar status för {{ selectedRoomIds.length }} rum</strong></p>
          <ul class="statuses">
            <li 
            v-bind:class="index" 
            v-for="(status, index) in statuses" @click="updateMultipleRoomStatus(index)"
            v-bind:key="index"
            >
              <span v-html="status"></span>
            </li>
          </ul>
        </div>

        <div id="panel" v-if="panelOpen === true">
          <p><strong>Status for {{ currentRoom.id }}</strong></p>
          <ul id="statuses">
            <li 
            v-for="(status, index) in statuses" 
            v-bind:key="index"
            @click="updateRoomStatus(index)"
            >{{ index }} {{ status }}</li>
          </ul>
        </div>
      </template>
    </section>

    <transition name="slide-up">
      <div class="new-note" v-if="new_note_ui === true">
        <div class="input-container">
          <textarea name="note" id="note" v-model="notes.new_note.title" cols="30" rows="10" placeholder="Skriv en notering eller något som behöver göras här..."></textarea>
        </div>
        <div class="input-container">
          <ul class="alternative-list">
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(1, notes.new_note)}"
            v-on:click="toggleAudienceForNote(1, notes.new_note)"
            >Alla</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(2, notes.new_note)}"
            v-on:click="toggleAudienceForNote(2, notes.new_note)"
            >Reception</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(3, notes.new_note)}"
            v-on:click="toggleAudienceForNote(3, notes.new_note)"
            >Städ</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(4, notes.new_note)}"
            v-on:click="toggleAudienceForNote(4, notes.new_note)"
            >Vaktmästare</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(5, notes.new_note)}"
            v-on:click="toggleAudienceForNote(5, notes.new_note)"
            >Ledning</li>
          </ul>
        </div>
        
        <div class="input-container">
          <button class="primary" v-if="notes.new_note.title !== '' && notes.new_note.audience_ids.length > 0" v-on:click="createNote">Spara</button>
          <button class="secondary" v-on:click="cancelCreateNote">Stäng</button>
        </div>
      </div>
    </transition>

    <transition name="slide-up">
      <div class="new-note" v-if="editing_note !== false">
        <div class="input-container">
          <textarea name="note" id="note" v-model="editing_note.title" cols="30" rows="10" placeholder="Skriv en notering eller något som behöver göras här..."></textarea>
        </div>
        <div class="input-container">
          <label for="">Visa för</label>
          <ul class="alternative-list">
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(1, editing_note)}" 
            v-on:click="toggleAudienceForNote(1, editing_note)"
            >Alla</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(2, editing_note)}" 
            v-on:click="toggleAudienceForNote(2, editing_note)"
            >Reception</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(3, editing_note)}" 
            v-on:click="toggleAudienceForNote(3, editing_note)"
            >Städ</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(4, editing_note)}" 
            v-on:click="toggleAudienceForNote(4, editing_note)"
            >Vaktmästare</li>
            <li 
            v-bind:class="{'selected': audienceEnabledForNote(5, editing_note)}"
            v-on:click="toggleAudienceForNote(5, editing_note)"
            >Ledning</li>
          </ul>
        </div>
        
        <div class="input-container">
          <button class="primary" v-if="editing_note.title !== ''" v-on:click="updateNote">Spara</button>
          <button class="secondary" v-on:click="editing_note = false">Stäng</button>
        </div>
      </div>
    </transition>

    <div id="primary-nav" v-bind:data-appstate="appstate">
      <button class="open-rooms" v-on:click="appstate = 'rooms'"><i class="fas fa-door-closed"></i> <span class="label">Rum</span></button>
      <button class="open-notes" v-on:click="appstate = 'notes'"><i class="fas fa-check-square"></i> <span class="label">Checklista</span></button>
      <button class="open-help" v-on:click="showHelp = true"><i class="fas fa-question-circle"></i> <span class="label">Hjälp</span></button>
      <button v-bind:data-reloading="reloading" class="update" v-on:click="reloadAppData"><i class="fas fa-redo-alt"></i></button>
    </div>
    <div 
      class="dialog"
      v-if="dialog.text !== ''"
    >
      <p>{{ dialog.text }}</p>
      <button
        v-on:click="dialog.text = ''"
      >Stäng</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import Notes from './components/Notes.vue';
import RoomNotes from './components/RoomNotes.vue';

export default {
  name: 'app',
  components: {
    Notes,
    RoomNotes
  },
  created() {
    let self = this;
    this.interval = setInterval(function(){
      self.loadRooms();
    }, 120000);
  },
  data: function () {
    return {
      api_url: process.env.VUE_APP_API_URL,
      appstate: 'rooms',
      audiences: [],
      currentRoom: false,
      currentPanelTab: 'statuses',
      dialog: {
        text: ''
      },
      rooms: [],
      roomslookup: {},
      editing_note: false,
      new_note_ui: false,
      note_audience_filter: 1,
      notes: {
        current: [],
        recent: [],
        new_note: {
          title: '',
          is_todo: 1,
          audiences: [],
          audience_ids: [],
          room_id: false
        }
      },
      room_status_filter: '',
      roomSearch: '',
      reloading: false,
      selectingMultiple: false,
      selectedRoomIds: [],
      showFilterBar: false,
      showHelp: false,
      showSearchBar: false,
      statuses: {
        prioritized: "<i class='far fa-star'></i> Prioriterat",
        checkedout: "<i class='fas fa-sign-out-alt'></i> Utcheckad",
        occupied: "<i class='fas fa-ban'></i> Upptaget",
        cleaning: "<i class='fas fa-broom'></i> Påbörjat",
        clean: "<i class='far fa-check-circle'></i> Städat",
        cleanwaiting: "<i class='far fa-plus-square'></i> Tillval ska in",
        control: "<i class='far fa-check-circle'></i> Kontrollera",
        stay: "<i class='far fa-pause-circle'></i> Stanna",
        renovating: "<i class='fas fa-tools'></i> Renoveras",
      },
      panelOpen: false,
      client: {
        token: ""
      }
    }
  },
  methods: {
    validateToken(){
      let token = this.$route.query.token
      this.client.token = token;
    },
    log(msg){
      console.log(msg);
      return msg;
    },
    toggleFilterBar(){
      this.showFilterBar = !this.showFilterBar;
    },
    toggleSearchBar(){
      let self = this;
      this.showSearchBar = !this.showSearchBar;
      if( this.showSearchBar ){
        setTimeout(function(){
          self.$refs.searchInput.focus();
        }, 50);
      }
    },
    clearAndCloseSearch(){
      this.roomSearch = '';
      this.showSearchBar = false;
    },
    setRoomStatusFilter(key){
      if( this.room_status_filter === key ){
        this.room_status_filter = '';
      } else {
        this.room_status_filter = key;
      }
    },
    openNoteUi(room){
      this.new_note_ui = !this.new_note_ui;
      this.notes.new_note.room_id = room.id;
      setTimeout(function(){
        document.getElementById('note').focus();
      }, 50);
    },
    closeNoteUi(){
      this.new_note_ui = false;
      this.notes.new_note.room_id = false;
    },
    cancelCreateNote(){
      this.new_note_ui = false;
      this.notes.new_note.title = '';
      this.notes.new_note.is_todo = 0;
      this.notes.new_note.audience = 1;
      this.notes.new_note.room_id = false;
      this.notes.new_note.audiences = [];
    },
    createNote(){
      let self = this;
      this.log('Making call for createNote');
      axios
      .post(
        this.api_url + "/note",
        {
          title: self.notes.new_note.title,
          is_todo: self.notes.new_note.is_todo,
          audience_id: self.notes.new_note.audience,
          room_id: self.notes.new_note.room_id,
          audience_ids: self.notes.new_note.audience_ids
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + self.client.token
          }
        }
      )
      .then(function(response) {
        self.currentRoom.notes.current.push(response.data);
        self.notes.new_note.title = '';
        self.notes.new_note.is_todo = false;
        self.notes.new_note.audience_id = 1;
        self.notes.new_note.room_id = false;
        self.loadNotes();
        self.closeNoteUi();
        self.loadRooms();
      })
      .catch(function(error) {
        self.log(error);
        self.log("Something went wrong while logging in");
      });
    },
    editNote(note){
      this.editing_note = note;
      return;
    },
    updateNote(){
      let self = this;
      this.log('Making call for updateNote');
      axios
      .put(
        this.api_url + "/note/" + self.editing_note.id,
        {
          note_id: self.editing_note.id,
          title: self.editing_note.title,
          audience_id: self.editing_note.audience,
          audience_ids: self.editing_note.audience_ids
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + self.client.token
          }
        }
      )
      .then(function() {
        self.loadNotes();
        self.editing_note = false;
      })
      .catch(function(error) {
        this.log(error);
        this.log("Something went wrong while logging in");
      });

    },
    loadNotes(){
      this.log('Loading notes via new way');
      let self = this;
      self.reloading = true;

      axios
      .get(
        self.api_url + '/notes',
        {
          params: {
            audience_ids: []
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + self.client.token
          }
        },        
      )
      .then( response => {
        self.log('Notes data:');
        self.log(response);
        self.reloading = false;
        self.loadRooms();
      })
    },
    audienceEnabledForNote(audience_id, note){
      let exists = note.audience_ids.indexOf(audience_id) > -1; 
      if( exists ){
        return true;
      } else {
        return false;
      }
    },
    toggleAudienceForNote(audience_id, note){
      let exists = note.audience_ids.indexOf(audience_id) > -1;
      if( !exists ){
        note.audience_ids.push(audience_id);
      } else {
        note.audience_ids.splice(note.audience_ids.indexOf(audience_id), 1);
      }
    },
    openRoomNotesUi(){
      this.log('Showing notes');
    },
    toggleDone(note){
      let self = this;
      this.log('Making call for toggle Done');
      axios
        .put(
          self.api_url + "/note/" + note.id + "/done",
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + self.client.token
            }
          }
        )
        .then(function(response){
          self.log(response);
          note.done = !note.done;
          self.loadNotes();
        })
        .catch(function(error) {
          this.log(error);
          this.log("Something went wrong while logging in");
        });
    },
    loadRooms() {
      let self = this;
      self.reloading = true;
      this.log('Making call for loadRooms');
      axios
        .get(this.api_url + "/app", {
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            Authorization: "Bearer " + self.client.token
          }
        })
        .then(response => {
          self.rooms = response.data.rooms;
          if( self.audiences.length === 0 ){
            self.audiences = response.data.audiences;
          }

          Object.keys(self.rooms).map(function(objectKey) {
            var room = self.rooms[objectKey];
            self.roomslookup[room.id] = room.name;

            if( room.id === self.currentRoom.id ){
              Vue.set(room, "open", true);
              Vue.set(room, "loading", false);
            } else {
              Vue.set(room, "open", false);
              Vue.set(room, "loading", false);
            }
          });
          self.reloading = false;
        })
        .catch(function(error) {
          self.log(error);
          self.log("Something went wrong while logging in (loadRooms)");
          self.dialog.text = 'Något gick snett, följde du verkligen en korrekt länk för att hamna här? Försök igen.';
        });
    },
    reloadAppData(){
      if( this.reloading == false ){
        let self = this;
        self.loadRooms();
        self.loadNotes();
      }
    },
    toggleSelectingMultiple(){
      if( this.selectingMultiple ){
        this.selectedRoomIds = [];
      }
      this.selectingMultiple = !this.selectingMultiple;
    },
    toggleOrSelect(room){
      if( this.selectingMultiple ){
        if( this.selectedRoomIds.includes(room.id) ){
          var index = this.selectedRoomIds.indexOf(room.id);
          if (index > -1) {
            this.selectedRoomIds.splice(index, 1);
          }
        } else {
          this.selectedRoomIds.push(room.id);
        }
      } else {
        this.togglePanel(room);
      }
    },
    togglePanel(room) {
      this.currentPanelTab = 'statuses';

      
      // Todo close any other open room here?
      if (room.open) {
        this.currentRoom = false;
        
        this.loadCurrentRoomNotes();
        room.open = false;
      } else {
        this.currentRoom = room;
        
        this.currentRoom.notes = {};
        this.loadCurrentRoomNotes();
        
        room.open = true;
        
        this.loadNotes();
      }
    },
    loadCurrentRoomNotes(){
      let self = this;
      self.log('Running loadCurrentRoomNotes');
      self.log('Calling url: ' + self.api_url + "/rooms/" +  self.currentRoom.id + "/notes");
      self.reloading = false;
      axios
      .get(self.api_url + "/rooms/" +  self.currentRoom.id + "/notes", {
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json',
          Authorization: "Bearer " + self.client.token
        }
      })
      .then(response => {
        self.currentRoom.notes.current = response.data.active;
        self.currentRoom.notes.recent = response.data.recent;
        self.reloading = false;
      })
      .catch(function(error) {
        self.log(error);
        self.log("Something went wrong while loading notes for current room");
      });
    },
    updateRoomStatus(room, index) {
      if (index === "cancel") {
        room.open = false;
        this.currentRoom = false;
        return;
      }

      room.loading = true;
      room.open = false;
      let self = this;
      this.log('Making call for updateRoomStatus');
      axios
        .put(
          this.api_url + "/rooms/" + room.id + "/status/" + index,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + self.client.token
            }
          }
        )
        .then(response => {
          room.status = response.data.status;
          room.lastupdated = response.data.lastupdated;
          self.currentRoom = false;
        })
        .catch(function(error) {
          this.log(error);
          this.log("Something went wrong while logging in");
        });
    },
    updateMultipleRoomStatus(index) {
      if (index === "cancel") {
        this.selectingMultiple = false;
        this.selectedRoomIds = [];
        return;
      }

      let self = this;
      this.log('Making call for updateMultipleRoomStatus');
      axios
        .put(
          this.api_url + "/rooms/multiple/status/" + index,
          {roomIds: this.selectedRoomIds},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + self.client.token
            }
          }
        )
        .then(response => {
          this.rooms = response.data.rooms;
          this.selectingMultiple = false;
          this.selectedRoomIds = [];
        })
        .catch(function(error) {
          this.log(error);
          this.log("Something went wrong while logging in");
        });
    }
  },
  computed: {
    filteredNotes(){
      let self = this;
      var included_notes = [];
      
      if( this.note_audience_filter === 1 ){
        return this.notes.current;
      }
      this.notes.current.forEach( function(i){
        if( i.audience_id == self.note_audience_filter ){
          included_notes.push(i);
        }
      });
      return included_notes;
    },
    filteredRooms(){
      let self = this;
      var included_rooms = [];
      let include_filter = false;
      let include_search = false;

      if( this.room_status_filter === '' && this.roomSearch === '' ){
        return this.rooms;
      }

      this.rooms.forEach( function(i){
        include_filter = false;  
        include_search = true;  
        
        if( i.status === self.room_status_filter || self.room_status_filter === '' ){
          include_filter = true;
        }

        if( self.roomSearch !== '' ){
          if( i.name.indexOf(self.roomSearch) === -1 ){
            include_search = false;
          }
        }
        
        if( include_filter && include_search ){
          included_rooms.push(i);
        }
      });

      return included_rooms;
    }
  },
  watch: {
  },
  mounted: function(){
    this.validateToken(), this.loadRooms(), this.loadNotes();
  }
}
</script>

<style lang="scss">
@import 'assets/css/reset-min.css';
@import 'assets/css/_variables';
@import 'assets/css/_mixins';
@import 'assets/css/app';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.help {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;

  .iframe-container {
    position: relative;
    padding-bottom: 56.25vw;
    width: 100vw;
    height: 0px;

    button {
      position: fixed;
      top: 10px;
      right: 10px;
      padding: 10px 20px;
      background-color: $color_mango;
      color: #3f3f3f;
      border: none;
      z-index: 101;
    }

    iframe {
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      width: 100%;
      height: 100%;
    }
  }
}

.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 200px;
  max-width: 480px;
  text-align: center;
  transform: translateY(50%) translateX(-50%);
  padding: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 32px rgba(0,0,0,0.50);

  button {
    background-color: $color_mango;
    color: #3f3f3f;
    padding: 8px 20px;
    border: none;
    clear: both;
    margin: 10px auto 0;
    cursor: pointer;
  }
}

</style>
